import { FeatureFlags } from '@e2m-customer-portal/shared';
import { useEnvSettings } from '../use-env-settings/use-env-settings';

export function useFeatureFlags(): Readonly<FeatureFlags> {
  return useEnvSettings().featureFlags;
}
